import './icon.scss'
import { IChildren } from '@/interface'

export const Icon = ({ children, onClick }: IChildren) => {
    return (
        <div onClick={onClick} className='a-icon'>
            {children}
        </div>
    )
}
